import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export const faPlus: IconDefinition = {
  prefix: "fas",
  iconName: "plus",
  icon: [448, 512, [], "2b", "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z"],
};

export default faPlus;
